const isObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null;

const getDataProperty = (value: unknown) => (isObject(value) ? value.data : undefined);

// Supports both API shapes used by care-plan endpoints:
// - Standard: { data: [...] } / { data: { ... } }
// - Wrapped:  { data: { data: [...] } } / { data: { data: { ... } } }
const extractRecords = <T extends object = Record<string, unknown>>(queryData: unknown): T[] => {
  const responseData = getDataProperty(queryData);
  const nestedData = getDataProperty(responseData);
  const payload = nestedData ?? responseData;

  if (Array.isArray(payload)) return payload as T[];
  if (isObject(payload)) return [payload as T];
  return [];
};

export default extractRecords;